module.exports = __webpack_public_path__ + "static/slide1-0346126dd9f29904a396d0e10dc3f667.webp";